export const bucketIdentifiers = ["private", "public"] as const
export type BucketIdentifier = typeof bucketIdentifiers[number]

export type S3File = {
	bucket: BucketIdentifier;
	key: string;
	name: string;
	type: string;
	size: number;
	url?: string;
};

export type S3Put = {
	key: string;
	signedUrl: string;
}

// Type pour le stream S3 Response Body
export interface S3BodyStream {
	[Symbol.asyncIterator](): AsyncIterableIterator<Uint8Array>;
}
